<section class="voyage-details">
  <div class="top-section">
    <h3>
      Voyage Details
    </h3>
  </div>
  <div class="container">
    <div class="main-section">
      <div class="row topbar">
        <div class="col-6">
          <h4 class="mr-2" style="padding-left: 1.8em;">
            SCHEDULE DETAILS
          </h4>
        </div>
        <div class="col-6">
          <div *ngIf="cubicmeter > 0" class="float-md-right text-center  details">
            <div class="d-block ">
              <strong>$ {{cubicmeter}}</strong>
            </div>
            <!-- <p>
              cheapest option 42 $/cbm
            </p> -->
          </div>
          <div *ngIf="cubicmeter == null" class="details">
            <div class="d-block ">
              <span>
                There are no available rate for this segment.Please submit a freight
                request using the button below
              </span>
            </div>
            <!-- <p>
              cheapest option 42 $/cbm
            </p> -->
          </div>
        </div>
      </div>
      <div class="option-section">
        <div class="table-sec">
          <div class="table-responsive">
            <p-table [value]="voyageDetails" *ngIf="totalCount > 0" class="table">
              <ng-template pTemplate="body" let-result>
                <tr>
                  <td class="align-middle">
                    <div class="custom-control custom-radio custom-control-inline">
                      <p-radioButton name="group1" value="{{result.id}}" [(ngModel)]="selected" inputId="opt1">
                      </p-radioButton>
                    </div>
                  </td>
                  <td class="table-responsive">
                    <table class="table detail-tbl ">
                      <tr>
                        <td>
                          {{result.fromPortName}}
                          <strong class="d-block">
                            {{result.fromPortArrivalDate | date: 'dd-MM-yyyy'}}
                          </strong>
                        </td>
                        <td align="center" class="align-middle">
                          <div class="directImg" *ngIf="result.isTranshipment == 0">
                            Direct
                          </div>
                          <div class="directImg" *ngIf="result.isTranshipment == 1">

                          </div>
                        </td>
                        <td class="align-middle" *ngIf="result.isTranshipment == 1">
                          {{result.midPortName}}
                          <strong class="d-block">
                            {{result.midPortDepartureDate | date: 'dd-MM-yyyy'}}
                          </strong>
                        </td>
                        <td align="center" class="align-middle" *ngIf="result.isTranshipment == 1">
                          <div class="directImg">

                          </div>
                        </td>
                        <td class="align-middle">
                          {{result.toPortName}}
                          <strong class="d-block">
                            {{result.toPortArrivalDate | date: 'dd-MM-yyyy'}}
                          </strong>
                        </td>
                        <td align="middle" class="align-middle">
                          <strong> {{result.noOfDays}} Days Transit Time</strong>
                        </td>
                        <td class="align-middle">
                          <!-- {{result.tradeCode}} -->
                        </td>
                        <!-- <td class="align-middle" *ngIf="result.isTranshipment == 0">
                          <a href="">
                            {{result.vesselsName}}
                          </a>
                        </td> -->
                      </tr>
                    </table>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>


        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-6">
          <br />
          <h5 class="mr-2">
            <img src="{{companyLogo}}" class="wallenius-logo mr-2" alt="" srcset="" style="width: 7em;" />
            {{companyName}}
          </h5>

          <br />
          {{ fromVesselName }}
          {{fromTranshipmentSchedule?.voyageName}}
          <div>
            <table class="table detail-tbl" id="details-table">
              <tr *ngFor="let item of fromTranshipmentSchedule" [ngClass]="item.isSelectedPort==1 ? 'highlight':null">
                <td>
                  {{item?.voyageName}}
                </td>
                <td>
                  {{item.portName + ", " + item.countryName}}
                </td>
                <td>
                  {{item.eta | date: 'dd-MM-yyyy'}}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6" *ngIf="stateParams.trashipment == 1">
          <br />
          <h5 class="mr-2">
            <img src="{{toCompanyLogo}}" class="wallenius-logo mr-2" alt="" srcset="" style="width:7em;" />
            {{toCompanyName}}
          </h5>
          <br />
          {{ toVesselName }}
          <table class="table detail-tbl" id="details-table">
            <tr *ngFor="let item of toTranshipmentSchedule" [ngClass]="item.isSelectedPort==1 ? 'highlight':null">
              <td>
                {{item?.voyageName}}
              </td>
              <td>
                {{item.portName + ", " + item.countryName}}
              </td>
              <td>
                {{item.eta | date: 'dd-MM-yyyy'}}
              </td>
            </tr>
          </table>
        </div>
        <div class="col-1"></div>

      </div>
    </div>

    <div class="text-end mt-6 mb-2">
      <div class="serachresultfiter">
        ENL Solutions is not responsible for the accuracy of the information.The information can be changed by the
        shipping line at any time and without any notice
      </div>
      <button class="btn btn-signIn" (click)="bookingRequest()">Freight Rate/Booking Request</button>
    </div>
  </div>
</section>
